export type RevenueIntelligenceChatCatalogueMatchEntry = {
  contractIds: string[];
  topics: string[];
};

export function selectRevenueIntelligenceChatCatalogueEntry<
  TEntry extends RevenueIntelligenceChatCatalogueMatchEntry,
>(
  question: string,
  entries: TEntry[],
  activeContractIds: string[],
) {
  const normalizedQuestion = question.toLocaleLowerCase().trim();
  const activeIds = new Set(activeContractIds);
  const matches = entries.flatMap(entry => {
    const matchingTopics = entry.topics.filter(topic => {
      const normalizedTopic = topic.toLocaleLowerCase().trim();
      if (!normalizedTopic) return false;
      const escaped = normalizedTopic.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return new RegExp(`(^|[^\\p{L}\\p{N}])${escaped}([^\\p{L}\\p{N}]|$)`, "u")
        .test(normalizedQuestion);
    });
    if (!matchingTopics.length) return [];
    return [{
      entry,
      score: Math.max(...matchingTopics.map(topic => topic.length)),
      active: entry.contractIds.some(contractId => activeIds.has(contractId)),
    }];
  }).toSorted((a, b) => b.score - a.score || Number(b.active) - Number(a.active));
  return matches[0] ?? null;
}
